

// import * as THREE from 'three';
// import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { gsap } from 'gsap';
import { CustomEase } from 'gsap/CustomEase';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Lenis from '@studio-freight/lenis';
import barba from '@barba/core';
import $ from 'jquery';
import 'jquery-match-height';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import ScrollHint from 'scroll-hint';
// import 'scroll-hint/css/scroll-hint.css';
// import { initCategoryTabs } from './categoryTabUtils.js';
// import { initModal } from './modalUtils.js';
// import { initAccordion } from "./accordionUtils.;js";
// import { preventEnterSubmit } from "./formUtils.js"
// import { initHeaderScrollBehavior } from "./initHeaderScrollBehavior.js";
// import { initSwiper } from "./initSwiper.js"
import { deviceBrowserCheck } from "./deviceBrowserCheck.js";
// import { pageLeaveAnimationPixel, startNoisePhase, startDissolvePhase } from './pageLeaveAnimationPixel.js';
// pageLeaveAnimationPixel(); // 初回だけ呼ぶ（初期化）
import { webglWaveInit } from "./gl.js";
import { swichImgInit } from "./swichImg.js";
import { cursorFollowInit } from "./cursorFollowInit.js";
import { mvHoverBubble } from "./mvHoverBubble.js"

gsap.registerPlugin(ScrollTrigger);
gsap.config({
  nullTargetWarn: false,   // 存在しないターゲットに対する警告を非表示にする
  trialWarn: false         // GSAPのプラグインライセンス関連の警告を非表示にする
});
// import { OrbitControls } from 'OrbitControls';
// import { GUI } from 'dat.gui';
// lenis
const isSP = window.innerWidth <= 767;


if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

function reloadPageOnResize() {
  const initialWidth = window.innerWidth;
  let resizeTimeout;

  window.addEventListener('resize', () => {
    const currentWidth = window.innerWidth;

    clearTimeout(resizeTimeout); // 前回のタイマーをクリア
    resizeTimeout = setTimeout(() => {
      if (currentWidth !== initialWidth) {
        // ページをリロード
        location.reload();
      }
    }, 300); // 300ms 待機
  });
}
reloadPageOnResize();


window.addEventListener('load', () => {
  scrollTopInit();
});



deviceBrowserCheck();
cursorFollowInit();
// vivusDurationcalc()



function easeOutCirc(x) {
  // return Math.sqrt(1 - Math.pow(x - 1, 2));
  return 1 - Math.pow(1 - x, 4);
}
// const lenis = new Lenis({
//   duration: 1.2,     // スクロールにかかる時間（大きいほど重くなる）
//   // lerp: 0.2, // 慣性の強さ
//   easing: easeOutCirc, // カスタムイージング関数
//   // easing: (t) => 1 - Math.pow(1 - t, 4) // easeOutQuart
//   // easing: (t) => t * (2 - t), // easeOutQuad（自然でバランスがいい）
// });
// function raf(time) {
//   lenis.raf(time);
//   requestAnimationFrame(raf);
// }
// requestAnimationFrame(raf);


/* ==============================
   Lenis 初期化（統合・最適版）
   あなたの wrapper / content 名を使用
   easing, lerp も維持
   ＋ 参考コードの touch/wheel 設定を追加
============================== */
const wrapper = document.querySelector('.l_wrapper');
const content = document.querySelector('.l_scroller');

// 端末判定
const isFirefox = navigator.userAgent.toLowerCase().includes("firefox");
const scrollBlakePoint = window.innerWidth < 1024 && window.innerHeight < 1024; 
// ↑ 本家コードに合わせたスマホ判定

const lenis = new Lenis({
  wrapper: wrapper,
  content: content,
  easing: easeOutCirc,
  lerp: 0.05,

  syncTouch: isSP ? true : true, //スマホでlenisを有効にする
  syncTouchLerp: 0.05,

  smoothTouch: isSP ? false : true,

  touchInertiaMultiplier: 21,
  touchMultiplier: 1.2,
  wheelMultiplier: 1,

  gestureOrientation: isSP ? "vertical" : "vertical",
  allowNestedScroll: true,
});

/* ------------------------------
   GSAP 連動
------------------------------ */
gsap.ticker.add((time) => {
  lenis.raf(time * 1000);
});
gsap.ticker.lagSmoothing(0);

lenis.on("scroll", ScrollTrigger.update);

/* ------------------------------
   ScrollTrigger proxy
------------------------------ */
ScrollTrigger.scrollerProxy('.l_wrapper', {
  scrollTop(value) {
    return arguments.length
      ? lenis.scrollTo(value, { immediate: true })
      : lenis.scroll;
  },
  getBoundingClientRect() {
    return {
      top: 0, left: 0,
      width: window.innerWidth,
      height: window.innerHeight
    };
  }
});

ScrollTrigger.defaults({
  scroller: '.l_wrapper'
});







// =====================================
// ヘッダー＆メニュー周りのスクリプト
// =====================================
function headerMenuScript() {
  const navTargets = document.querySelectorAll(".c_header_nav, .c_header_nav_bg");
  const openTrigger = document.querySelector(".c_header_menuTlg");
  const closeTriggers = document.querySelectorAll(".c_header_close");
  if (!navTargets.length || !openTrigger || !closeTriggers.length) return;

  // gsap.set(nav, { autoAlpha: 0 });

  function openMenu() {
    gsap.to(navTargets, { autoAlpha: 1, duration: 0.3, overwrite: "auto" });
  }

  function closeMenu() {
    gsap.to(navTargets, { autoAlpha: 0, duration: 0.3, overwrite: "auto" });
  }

  openTrigger.addEventListener("click", () => {
    openMenu();
  });

  closeTriggers.forEach((closeTrigger) => {
    closeTrigger.addEventListener("click", () => {
      closeMenu();
    });
  });

  if (isSP) {
    const navLinks = document.querySelectorAll(".c_header_nav a");
    navLinks.forEach((navLink) => {
      navLink.addEventListener("click", () => {
        closeMenu();
      });
    });
  }
}


headerMenuScript();

// Vivus.jsのスクリプト
////////////////////////////////////////////////////////////////////
// balba.js
////////////////////////////////////////////////////////////////////


// すべてのlenisのアンカーリンクを取得
const anchors = document.querySelectorAll(".c_header_nav > a");
// すべてのアンカーに対してイベントリスナーを設定
anchors.forEach(anchor => {
  anchor.addEventListener("click", (e) => {
    // data-scroll-target属性を取得
    const target = anchor.getAttribute("data-scroll-target");
    if (!target) return;

    const href = anchor.getAttribute("href") || "";
    const currentURL = window.location.href.split("#")[0];
    const hrefURL = new URL(href, window.location.origin).href.split("#")[0];

    // 同一ページのアンカーのみJSでスクロール（他は通常遷移）
    if (currentURL !== hrefURL) return;

    e.preventDefault();
    lenis.start();

    setTimeout(() => {
      lenis.scrollTo("#" + target, {
        duration: 1.5,  // スクロールにかける時間（ミリ秒）
        offset: 50,
        // easing: 'easeInOutCubic'  // イージング関数
      });
      // lenis.scrollTo(0);
    }, 0);
  });
});


function scrollTopInit(link) {

  const hashTarget = window.location.hash.replace("#", "");
  if (hashTarget) {
    const targetEl = document.getElementById(hashTarget);
    if (targetEl) {
      setTimeout(() => {
        lenis.scrollTo(targetEl, {
          duration: 2,
          lerp: 0.2,
          offset: 50,
          immediate: true
        });
      }, 1500);
      return;
    }
  }

  // lenis.stop(); // 必要に応じてコメント解除


  // リンクをクリックした場合はtrue、それ以外（ブラウザバックなど）
  if (link && link instanceof Element) {
    console.log("リンクをクリック")
    const href = link.getAttribute('href'); // href属性を取得
    const target = link.getAttribute('data-scroll-target'); // data-scroll-targetを取得
    // console.log(`クリックされたリンクのhref: ${href}, ターゲット: ${target}`);

    // href と現在のURLが一致しているか確認
    const currentURL = window.location.href.split('#')[0]; // #以降を除外して現在のURLを取得
    const hrefURL = new URL(href, window.location.origin).href.split('#')[0]; // 絶対URLとしてhrefを解析
    console.log(hrefURL)
    console.log(currentURL)
    if (currentURL === hrefURL && target) {
      // hrefが現在のURLと一致し、ターゲットが指定されている場合
      const targetElement = document.querySelector(`#${target}`);
      if (targetElement) {
        setTimeout(() => {
          // lenis.scrollTo(0, {
          //   duration: 0,  // スクロールにかける時間（ミリ秒）
          // });
          console.log("分岐点（Anker Link）");
          // const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset; // スクロール位置を計算
          // console.log(targetPosition)
          // window.scrollTo({
          //   top: targetPosition,
          //   behavior: 'smooth'
          // });
          setTimeout(() => {
            // ScrollTrigger.clearScrollMemory();
            // ScrollTrigger.refresh();
          }, 400);
          setTimeout(() => {
            const targetId = target;
            const isSP = window.innerWidth <= 767;
            const container = isSP ? undefined : document.querySelector('.hs_scroller');

            let targetPos;

            const target = document.getElementById(targetId);
            if (!target) return;
            targetPos = isSP ? target.offsetTop : target.offsetTop;

            lenis.scrollTo(targetPos, {
              duration: 2,
              lerp: 0.2,
              container: container
            });



          }, 500);
        }, 500);
        // return;
      }
    } else {
      // 一致しない、またはターゲットが指定されていない場合のデフォルト処理
      console.log("分岐点1")
      setTimeout(() => {
        lenis.scrollTo(0, {
          duration: 0,  // スクロールにかける時間（ミリ秒）
        });
        // if (currentNamespace === 'index') {
        //   document.querySelector('.c_header').classList.remove('is_dark');
        //   document.querySelector('.c_sideBar').classList.remove('is_dark');
        //   document.querySelector('.progressBar').classList.remove('is_dark');
        //   document.querySelectorAll('.js_bgDark').forEach(el => {
        //     el.classList.remove('is_active');
        //   });
        // } else {
        //   document.querySelector('.c_header').classList.remove('is_dark');
        //   document.querySelector('.c_sideBar').classList.remove('is_dark');
        //   document.querySelectorAll('.js_bgDark').forEach(el => {
        //     el.classList.remove('is_active');
        //   });
        // }
        setTimeout(() => {
          // ScrollTrigger.clearScrollMemory();
          // ScrollTrigger.refresh();
        }, 500);
      }, 500);
    }
  } else {
    console.log("分岐点2")
    setTimeout(() => {
      lenis.scrollTo(0, {
        duration: 0,  // スクロールにかける時間（ミリ秒）
      });
      setTimeout(() => {
        // ScrollTrigger.clearScrollMemory();
        // ScrollTrigger.refresh();
      }, 500);
    }, 500);
  }
}





function delay(n) {
  n = n || 2000;
  return new Promise((done) => {
    setTimeout(() => {
      done();
    }, n);
  });
}

// let currentNamespace = document.querySelector('main[data-barba-namespace]')?.getAttribute('data-barba-namespace') || null;
// barba.init({
//   transitions: [{
//     name: 'default-transition',
//     // 現在のページを離れる時のフック
//     leave: function (data) {
//       // 現在のページを離れる時のアニメーションを設定する
//       return new Promise(function (resolve) {
//         leaveAnimation(data.current.container);
//         setTimeout(function () {
//           resolve();
//           // ScrollTrigger.getAll().forEach(trigger => trigger.kill(true)); // ← trueを指定してDOMからも消す
//         }, 600);
//       });
//     },
//     // 次のページを表示する時のフック
//     enter: function (data) {
//       // ScrollTrigger.getAll().forEach(trigger => trigger.kill(true)); // ← trueを指定してDOMからも消す
//       // ScrollTrigger.refresh();
//       window.scrollTo(0, 0);
//       // クリックされたリンク情報を取得
//       const clickedLink = data.trigger;

//       // scrollTopInitにリンク情報を渡す
//       scrollTopInit(clickedLink);
//       enterAnimation(data.next.container);
//       // enterAnimation(data.next.container);
//     }
//   }]
// });

// barba.hooks.beforeEnter((data) => {
//   // lenis.stop();
//   // console.log("Lenisストップした。")
//   // 遷移先が "home" の場合にのみ initializeAnimations() を呼び出す
//   // setTimeout(() => {
//   //   window.scrollTo(0, 0);
//   //   const scrollElem = document.scrollingElement || document.documentElement
//   //   scrollElem.scrollTop = 0;
//   //   console.log("setTimeout後のスクロール位置:", window.scrollY);
//   // }, 100);
//   currentNamespace = data.next.namespace;
//   document.body.classList.remove('index', 'sb'); // 既存のクラスを一旦削除
//   if (data.next.namespace === 'index') {
//     document.body.classList.add('index');
//     document.body.classList.remove('sb'); // .sbを削除
//   } else {
//     document.body.classList.add('sb');
//     document.body.classList.remove('index'); // .indexを削除
//   }
//   // if (data.next.namespace === "contact") {
//   //   document.querySelector('.cfoot').style.display = 'none';
//   // } else {
//   //   document.querySelector('.cfoot').style.display = 'block';
//   // }
//   // lenis.stop();
//   // pageLoadedAnimation01()
//   function callAllFunctions() {
//     replaceHeadTags(data.next);
//     commonScriptInit();
//     // onWindowLoadScriptInit();
//     // isWindowLoaded = true;
//     // checkAndRunOnWindowLoadScriptInit();
//     onLoadingComplete_mvAnimationInit(); //MVのアニメーション
//     // webglTrigger()
//     // console.log("遷移後の処理完了")
//   }
//   setTimeout(callAllFunctions, 100);
// });

// barba.hooks.afterEnter(() => {
//   // scrollTopInit();
//   // setTimeout(() => {
//   //   window.scrollTo(0, 0);
//   // }, 100);
// });

function leaveAnimation(target) {
  // boostStarRotation(); // ← ここで回転ブースト発動
  gsap.to(".c_main , footer", {
    opacity: 0,
    duration: 0.6,
    // filter: "blur(20px)"
  });
}

// 通常のbalbaのenterアニメーション
function enterAnimation(e) {
  // console.log("enterAnimation Start")
  gsap.to(".c_main, footer", {
    opacity: 1,
    duration: 0.5,
    // filter: "blur(0px)",
    delay: 1,
  } // to（最終状態）
  );
}


// 遷移時にheadの情報を変更する
function replaceHeadTags(target) {
  var $newPageHead = $('<head />').html($.parseHTML(target.html.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0], document, true));
  var headTags = [
    "meta[name='keywords']",
    "meta[name='description']",
    "meta[property^='og']",
    "meta[property^='fb']",
    "meta[name^='twitter']",
    "meta[name='robots']",
    "meta[itemprop]",
    "link[itemprop]",
    "link[rel='prev']",
    "link[rel='next']",
    "link[rel='canonical']",
  ].join(',');
  $('head').find(headTags).remove();
  $newPageHead.find(headTags).appendTo('head');
}
// 遷移時にheadの情報を変更する






////////////////////////////////////////////////////////////////////
// 全ページ共通部分 balba.jsの対象外でOK
////////////////////////////////////////////////////////////////////


////////////////////////////////////////////////////////////////////
// ページ毎に呼びだす
////////////////////////////////////////////////////////////////////



let isWindowLoaded = false;
let isCommonScriptInitComplete = false;

function commonScriptInit() {
  // initCategoryTabs();
  // initModal();
  // initAccordion();
  // preventEnterSubmit();

  document.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', function (event) {
      // event.preventDefault(); // 通常のリンク動作を防ぐ
      if (!document.body.classList.contains('is_disable')) {
        document.body.classList.add('is_disable'); // bodyにクラス追加

        // 4秒後にクラスを削除
        setTimeout(function () {
          document.body.classList.remove('is_disable');
        }, 2000); // 4秒
      }
    });
  });
  CustomEase.create("customBezier", "M0,0 C0.2,0.9,0.35,0.93 1,1");
  function adjustAspectRatio() {
    // js_aspectRatio クラスを持つすべての要素を取得
    const aspectRationElem = document.querySelectorAll('.js_aspectRatio');

    aspectRationElem.forEach((animationElem) => {
      // ウィンドウのビューポートサイズを取得
      const width = window.innerWidth;
      const height = window.innerHeight;

      // 16:9 の比率で高さを計算
      const aspectHeight = (width * 8.5) / 16;

      if (height > aspectHeight) {
        animationElem.style.width = 'auto';
        animationElem.style.height = '110%';
      } else {
        animationElem.style.width = '100%';
        animationElem.style.height = 'auto';
      }
    });
  }





  class SpanWrap {
    constructor(target) {
      this.target = this.convertElement(target);
      this.nodes = [...this.target.childNodes];
      this.convert();
    }

    convert() {
      let spanWrapText = "";
      this.nodes.forEach((node) => {
        if (node.nodeType == 3) { // テキストノードの場合
          const text = node.textContent.replace(/\r?\n/g, '');
          // テキストを <span><span> で囲んで連結
          spanWrapText = spanWrapText + this.wrapTextWithSpan(text);
        } else if (node.nodeType === 1 && node.classList.contains("js_tAnimation_elem")) {
          // js_tAnimation_elem 要素を <span><span> で囲むが中身はそのまま
          spanWrapText = spanWrapText + `<span><span>${node.outerHTML}</span></span>`;
        } else { // テキスト以外の要素 (例えば <br> など)
          spanWrapText = spanWrapText + node.outerHTML;
        }
      });
      this.target.innerHTML = spanWrapText;
    }

    wrapTextWithSpan(text) {
      return text.split('').reduce((acc, v) => {
        if (v === ' ') {
          // 半角スペースも <span> で囲む
          return acc + `<span class="space">&nbsp;</span>`;
        }
        return acc + `<span><span>${v}</span></span>`;
      }, "");
    }

    // jQueryオブジェクトや文字列セレクターを変換
    convertElement(element) {
      if (element instanceof HTMLElement) {
        return element;
      }
      if (element instanceof jQuery) {
        return element[0];
      }
      return document.querySelector(element);
    }
  }
  // スクリプトの適用
  const targets = [...document.querySelectorAll(".js_tAnimation_01,.js_mv_tAnimation_01,.js_slotTxt > span, .js_fadeTxt")]
  targets.forEach((target) => {
    new SpanWrap(target);
  });
  gsap.set('.js_fadeTxt span', {
    opacity: 0.2,
  });



  setTimeout(() => {
    const event = new CustomEvent('commonScriptInitComplete');
    document.dispatchEvent(event);
    // console.log('commonScriptInitComplete イベント発火');
  }, 100);

}

// windowLoad後に開始するべき関数 ※非同期遷移後には最後に起動
function onWindowLoadScriptInit() {
  $('.news_card').matchHeight();
  const isTop = document.querySelector(".index");

  mvHoverBubble();
  ScrollTrigger.config({
    ignoreMobileResize: true // モバイルのリサイズイベントを無視
  });



  ////////////////////////////////////////////////////
  // マップの座標修正処理
  //////////////////////////////////////////////////////
  // ===============================================
  // 📍 object-fit: cover 対応 ピン位置補正スクリプト
  // ===============================================
  // - 各 .js_arContainer 内の .js_arImg と .js_arPin を対象に、
  //   object-fit: cover による拡大・トリミングを補正して
  //   正しい位置にピンを再配置します。
  // - CSS上の top/left(rem指定) をそのまま使ってOK。
  // - デバッグ用に各計算ステップの値を console に出力。
  // ===============================================

  // const headerNewsList = document.querySelector('.c_newsList');
  // if (headerNewsList) {
  //   ScrollTrigger.create({
  //     trigger: document.body,
  //     start: 'top top-=50%',
  //     end: 'bottom top',
  //     onEnter: () => gsap.to(headerNewsList, { autoAlpha: 0, duration: 0.2, overwrite: 'auto' }),
  //     onLeaveBack: () => gsap.to(headerNewsList, { autoAlpha: 1, duration: 0.2, overwrite: 'auto' })
  //   });
  // }

  const headerNewsList = document.querySelector('.c_newsList');
  const headerNewsClose = document.querySelector('.c_newsList_close');
  if (headerNewsList && headerNewsClose) {
    headerNewsClose.addEventListener('click', () => {
      gsap.to(headerNewsList, { autoAlpha: 0, duration: 0.2, overwrite: 'auto' });
    });
  }

  // function updateMarkerPosition() {
  //   document.querySelectorAll('.js_arContainer').forEach((container, idx) => {
  //     const img = container.querySelector('.js_arImg');
  //     const pins = container.querySelectorAll('.js_arPin');
  //     if (!pins.length) return; // ← img の有無では return しない

  //     // --- 元画像の自然サイズ（デフォルト: 1920x1080）---
  //     let naturalW = 1920;
  //     let naturalH = 1080;

  //     // 画像要素がある場合のみ、実サイズを採用（未ロードなら待って再実行）
  //     if (img) {
  //       if (!img.complete || !img.naturalWidth || !img.naturalHeight) {
  //         img.addEventListener('load', updateMarkerPosition, { once: true });
  //         return;
  //       }
  //       naturalW = img.naturalWidth;
  //       naturalH = img.naturalHeight;
  //     }

  //     const aspectRatio = naturalW / naturalH;

  //     // --- コンテナサイズ（実表示）---
  //     const containerW = container.clientWidth;
  //     const containerH = container.clientHeight;
  //     const containerRatio = containerW / containerH;

  //     // --- 比率維持で baseW/baseH を動的に再計算 ---
  //     let baseW, baseH;
  //     if (aspectRatio > containerRatio) {
  //       // 画像が横長 → コンテナの高さに合わせて拡縮
  //       baseH = containerH;
  //       baseW = containerH * aspectRatio;
  //     } else {
  //       // 画像が縦長 → コンテナの幅に合わせて拡縮
  //       baseW = containerW;
  //       baseH = containerW / aspectRatio;
  //     }

  //     // --- cover と同じ拡大率を計算 ---
  //     const scaleX = containerW / baseW;
  //     const scaleY = containerH / baseH;
  //     const scale = Math.max(scaleX, scaleY);

  //     // --- 拡大後の描画サイズとトリミング ---
  //     const scaledW = baseW * scale;
  //     const scaledH = baseH * scale;
  //     const offsetX = (scaledW - containerW) / 2;
  //     const offsetY = (scaledH - containerH) / 2;

  //     // --- デバッグ出力 ---
  //     const branch = scaleX >= scaleY ? '横フィット（上下トリミング）' : '縦フィット（左右トリミング）';
  //     console.group(`📍 MAP ${idx + 1} - ${branch}`);
  //     console.table({
  //       hasImg: !!img,
  //       naturalW,
  //       naturalH,
  //       aspectRatio,
  //       containerW,
  //       containerH,
  //       baseW,
  //       baseH,
  //       scaleX,
  //       scaleY,
  //       scale,
  //       offsetX,
  //       offsetY,
  //     });

  //     // --- ピン座標を補正 ---
  //     pins.forEach((pin, j) => {
  //       const cs = getComputedStyle(pin);
  //       const top0 = parseFloat(cs.top) || 0;
  //       const left0 = parseFloat(cs.left) || 0;

  //       const realTop = top0 * scale - offsetY;
  //       const realLeft = left0 * scale - offsetX;

  //       pin.style.top = `${realTop}px`;
  //       pin.style.left = `${realLeft}px`;

  //       console.table({ pin: j + 1, top0, left0, realTop, realLeft });
  //     });

  //     console.groupEnd();
  //   });
  // }
  // updateMarkerPosition()


  // // --- 💻 PCのときだけ実行するUA判定 ---
  // function isPC() {
  //   const ua = navigator.userAgent.toLowerCase();
  //   return !(
  //     ua.includes('iphone') ||
  //     ua.includes('ipod') ||
  //     ua.includes('ipad') ||
  //     ua.includes('android')
  //   );
  // }

  // // 初回実行
  // if (isPC()) {
  //   updateMarkerPosition();
  //   window.addEventListener('resize', updateMarkerPosition);
  // }
  // updateMarkerPosition();
  // window.addEventListener('resize', updateMarkerPosition);












  ///////////////////////////////////////////////////////////////////
  // 横スクロールの基礎
  ////////////////////////////////////////////////////////////////////

  // enterAnimation()
  // setTimeout(() => {
  // }, 200);







  ///////////////////////////////////////////////////////////////////
  // MVアニメーション スプラッシュ後は別途下で起動
  ////////////////////////////////////////////////////////////////////

  function mv_animationInit() {
    const mv = document.querySelector(".mv");
    if (!isTop) return;
    ScrollTrigger.create({
      trigger: mv,
      start: isSP ? "bottom bottom" : "top top",
      end: () => `+=${window.innerHeight * 3}`, // 画面の高さ分固定
      pin: true,
      pinSpacing: false, // 固定解除後にスペースを作らない
      // markers: true, // デバッグ用
    });
  }

  // 関数呼び出し
  mv_animationInit();





  ///////////////////////////////////////////////////////////////////
  // ABOUTのアニメーション 水流が流れるまで
  ////////////////////////////////////////////////////////////////////

  function about_animationInit() {
    if (!isTop) return;
    gsap.to(".about_bg_b", {
      
      y: isSP ? "20%" : "40%",
      ease: "none",
      scrollTrigger: {
        trigger: ".about_bg_b",
        start: "top bottom", // 上端が画面の下端に来たら
        end: () => isSP ? `+=${window.innerHeight * 2.5}` : `+=${window.innerHeight * 2.5}`, // 画面の高さ分で完了
        scrub: true, // スクロール連動
        // markers: true, // デバッグ用
      },
    });
    gsap.to(".about_txtArea", {
      ease: "none",
      scrollTrigger: {
        trigger: ".about_txtArea", // ← スタートトリガー
        start: "top top",
        endTrigger: ".about",
        end: "bottom bottom",
        pin: true,
        pinSpacing: false,
        scrub: true,
        // markers: true, // デバッグ用
      },
    });
    gsap.to(".about_wave", {
      ease: "none",
      opacity: 1,
      scrollTrigger: {
        toggleActions: 'play none none reverse',
        trigger: ".about_txtArea", // ← スタートトリガー
        start: "top top",
        endTrigger: ".about",
        end: "bottom bottom",
        // pin: true,
        // pinSpacing: false,
        // scrub: true,
        // markers: true, // デバッグ用
      },
    });
    gsap.to(".about_bg_f", {
      ease: "none",
      scrollTrigger: {
        toggleActions: 'play none none reverse',
        trigger: ".about_bg_f", // ← スタートトリガー
        start: "bottom bottom",
        endTrigger: ".about",
        end: "bottom top",
        pin: true,
        pinSpacing: false,
        scrub: true,
        // markers: true, // デバッグ用
      },
    });
    gsap.to(".mv", {
      opacity: 0.01,
      duration: 0.5,
      delay: 0.5,
      ease: "power2.inOut",
      scrollTrigger: {
        toggleActions: 'play none none reverse',
        trigger: ".about_txtArea", // ← スタートトリガー
        start: "center center",
        endTrigger: ".about",
        end: "bottom top",
      },
    });
    gsap.to(".about", {
      // opacity: 0.01,
      autoAlpha: 0,
      duration: 0.4,
      ease: "power2.inOut",
      scrollTrigger: {
        toggleActions: "play none none reverse",
        trigger: ".about",
        start: "bottom bottom",
        // onComplete: () => {
        //   console.log("コンプリ")
        //   const el = document.querySelector(".about");
        //   if (el) el.style.pointerEvents = "none";
        // },
        // onReverseComplete: () => {
        //   console.log("リバコン")
          
        //   const el = document.querySelector(".about");
        //   if (el) el.style.pointerEvents = "auto";
        // },
      },
    });


    function aboutTextAnimationInit() {
      const wrappers = gsap.utils.toArray(".about_txtWrapper");
      if (!wrappers.length) return;

      wrappers.forEach((wrapper) => {
        const texts = gsap.utils.toArray(".about_txt_el", wrapper);
        if (!texts.length) return;

        const about = wrapper.closest(".about") || wrapper;
        const total = texts.length;
        const threshold = 0.2;
        const fadeRange = 0.8 - threshold;

        gsap.timeline({
          scrollTrigger: {
            trigger: wrapper,
            start: "top top",
            endTrigger: about,
            end: "bottom bottom",
            scrub: true,
            // markers: true,
            onUpdate: (self) => {
              const progress = self.progress;
              const localProgress = gsap.utils.clamp(0, 1, (progress - threshold) / fadeRange);

              texts.forEach((el, i) => {
                const startStep = i / total;
                const endStep = (i + 1) / total;
                let opacity = 0.2;

                if (localProgress >= startStep && localProgress <= endStep) {
                  const t = (localProgress - startStep) / (endStep - startStep);
                  opacity = gsap.utils.mapRange(0, 1, 0.2, 1, t); // 0.2〜1へ
                } else if (localProgress > endStep) {
                  opacity = 1; // 完全に通過した後も1のまま保持
                }

                el.style.opacity = opacity;
              });
            },
          },
        });

        texts.forEach((el) => (el.style.opacity = 0.2));
      });
    }
    aboutTextAnimationInit();
  }
  // 関数呼び出し
  about_animationInit();



  ///////////////////////////////////////////////////////////////////
  // MAPのアニメーション
  ////////////////////////////////////////////////////////////////////

  function map_animationInit() {
    if (!isTop) return;
    let currentPhase = null;
    function openPhase() {
      // gsap.killTweensOf(items.map(i => i.el));
      gsap.to(".mediaSlider", {
        autoAlpha: 1,
        y: 0,
        duration: 0.8,
        ease: "circ.out"
      });
    }
    function closePhase() {
      // gsap.killTweensOf(items.map(i => i.el));
      gsap.to(".mediaSlider", {
        autoAlpha: 0,
        y: 15,
        duration: 0.8,
        ease: "circ.out"
      });
    }

    gsap.to(".map_ttl", {
      autoAlpha: 1,
      duration: 0.3,
      delay: 0.4,
      ease: "power2.out",
      scrollTrigger: {
        trigger: ".map",
        start: "bottom bottom",
        toggleActions: "play none none reverse",
      },
    });

    gsap.to(".map_ttl", {
      scale: 0.6,
      ease: "none",
      scrollTrigger: {
        trigger: ".map",
        start: "bottom bottom",
        end: () => `+=${window.innerHeight * 0.5}`,
        scrub: true,
      },
    });


    const el = document.querySelector('.js_xscroll');
    const mapBar = document.querySelector('.map_bar span');
    const BREAKPOINT = 767;
    const ASPECT_RATIO_MAX = 1160 / 770;
    const isSpNow = () => window.innerWidth <= BREAKPOINT;
    const isNarrowAspect = () => {
      const w = window.innerWidth;
      const h = window.innerHeight || 1;
      return w / h <= ASPECT_RATIO_MAX;
    };
    const shouldUseSpMap = () => window.innerWidth <= BREAKPOINT || isNarrowAspect();
    const shouldCenterOnPc = () => window.innerWidth >= 768 && isNarrowAspect();
    const getScrollDistance = () => (el ? Math.max(0, el.scrollWidth - el.clientWidth) : 0);
    const lingerRatio = 0.3;
    const getLingerPx = () => (isSpNow() ? window.innerHeight * lingerRatio : 0);
    const pinEnd = () => `+=${window.innerHeight * 1 + (isSpNow() ? getScrollDistance() + getLingerPx() : 0)}`;
    const setMapBarProgress = (progress) => {
      if (!mapBar) return;
      const clamped = Math.max(0, Math.min(1, progress));
      gsap.set(mapBar, { scaleX: clamped, transformOrigin: "left center" });
    };

    /////////////////////////////////////////////
    // メディアスライダーの表示は無くなったのでピン留めだけ行う
    /////////////////////////////////////////////
    gsap.to(".map", {
      // y: "8%",
      ease: "none",
      scrollTrigger: {
        trigger: ".map",
        start: "top top", // 上端が画面の下端に来たら
        end: pinEnd,
        scrub: true, // スクロール連動
        pin: true,
        // markers: true, // デバッグ用
        // onUpdate: (self) => {
        //   const p = self.progress;

        //   // Phase01
        //   // if (p >= 0.5 && p < 0.6) {
        //   //   if (currentPhase === "phase01") return; // すでに実行済みならスキップ
        //   //   currentPhase = "phase01";
        //   //   openPhase();
        //   //   // closePhase(itemsPhase02);
        //   //   return;
        //   // }

        //   // 75% 進んだ時点で表示
        //   if (p >= 0.5) {
        //     if (currentPhase === "phase01") return; // すでに実行済みならスキップ
        //     currentPhase = "phase01";
        //     openPhase();
        //     // closePhase(itemsPhase02);
        //     return;
        //   }

        //   // // Phase02
        //   // if (p >= 0.70) {
        //   //   if (currentPhase === "phase02") return;
        //   //   currentPhase = "phase02";
        //   //   openPhase(itemsPhase02);
        //   //   closePhase(itemsPhase01);
        //   //   return;
        //   // }

        //   // それ以外（<0.2）
        //   if (currentPhase !== "none") {
        //     currentPhase = "none";
        //     closePhase();
        //     // closePhase(itemsPhase02);
        //   }
        // }
      },
    });



    // SP マップのスクロール値を調整
    // const el = document.querySelector('.js_xscroll');
    // const BREAKPOINT = 767;
    // const centerScroll = () => {
    //   console.log("centerScroll")
    //   el.scrollLeft = (el.scrollWidth - el.clientWidth) / 2;
    //   console.log(el.scrollLeft)
    // };
    // const resetScroll = () => {
    //   el.scrollLeft = 0;
    // };
    // const updateScroll = () => {
    //   if (window.innerWidth <= BREAKPOINT) {
    //     centerScroll();
    //   } else {
    //     resetScroll();
    //   }
    // };
    // // 初期
    // updateScroll();
    // // リサイズ時
    // addEventListener('resize', updateScroll);

    if (!el) return;

    let mapXScrollTween = null;
    const resetScroll = () => {
      el.scrollLeft = 0;
    };
    const centerScroll = () => {
      const left = (el.scrollWidth - el.clientWidth) / 2;
      el.scrollTo({ left, behavior: 'auto' });
    };

    let userTouched = false;
    const markTouched = () => { userTouched = true; };

    el.addEventListener('touchstart', markTouched, { passive: true });
    el.addEventListener('pointerdown', markTouched, { passive: true });
    el.addEventListener('wheel', markTouched, { passive: true });

    const setupMapXScroll = () => {
      if (mapXScrollTween) {
        mapXScrollTween.scrollTrigger?.kill();
        mapXScrollTween.kill();
        mapXScrollTween = null;
      }

      if (isSpNow()) {
        resetScroll();
        setMapBarProgress(0);
        mapXScrollTween = ScrollTrigger.create({
          trigger: ".map",
          start: "top top",
          end: pinEnd,
          scrub: true,
          onUpdate: (self) => {
            const total = self.end - self.start;
            if (total <= 0) return;
            const delayPx = Math.min(total, window.innerHeight);
            const lingerPx = getLingerPx();
            const scrollRange = Math.max(1, total - delayPx - lingerPx);
            const current = self.scroll() - self.start;
            const p = (current - delayPx) / scrollRange;
            const eased = Math.max(0, Math.min(1, p));
            el.scrollLeft = eased * getScrollDistance();
            setMapBarProgress(eased);
          },
        });
      } else {
        setMapBarProgress(0);
      }

      if (shouldCenterOnPc()) {
        setTimeout(() => {
          if (!userTouched) centerScroll();
        }, 1000);
      } else if (!shouldUseSpMap()) {
        resetScroll();
      }

      ScrollTrigger.refresh();
    };

    setupMapXScroll();
    window.addEventListener('resize', setupMapXScroll);


    if (window.innerWidth >= 768 && isNarrowAspect()) {
      const scrollHintTl = gsap.timeline({
        scrollTrigger: {
          trigger: ".map",
          start: "bottom bottom",
          toggleActions: "play none none none",
        }
      });
      scrollHintTl
        .set(".a_scrollHint", { autoAlpha: 0 })
        .to(".a_scrollHint", {
          autoAlpha: 1,
          duration: 0.3,
          delay: 0.4,
          ease: "power2.out"
        })
        .to(".a_scrollHint_hand", { x: -8, duration: 0.3, ease: "power1.inOut" })
        .to(".a_scrollHint_hand", { x: 8, duration: 0.3, ease: "power1.inOut" })
        .to(".a_scrollHint_hand", { x: -8, duration: 0.3, ease: "power1.inOut" })
        .to(".a_scrollHint_hand", { x: 8, duration: 0.3, ease: "power1.inOut" })
        .to(".a_scrollHint_hand", { x: 0, duration: 0.3, ease: "power1.inOut" })
        .to(".a_scrollHint", { autoAlpha: 0, duration: 0.3, delay: 0.5, ease: "power2.inOut" });
    }
    





    // マップからZOOMする処理
    const container = document.querySelector('.js_zoomContainer');
    const triggers = document.querySelectorAll('.js_zoomTrg');
    let isZoomed = false;
    let zoomTween = null;

    // --- ピンをクリックしたらズーム＆モーダル表示 ---
    triggers.forEach(trg => {
      trg.addEventListener('click', () => {
        const rect = trg.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();

        const pinCenterX = rect.left + rect.width / 2;
        const pinCenterY = rect.top + rect.height / 2;

        const viewportCenterX = window.innerWidth / 2;
        const viewportCenterY = window.innerHeight / 2;
        const zoom =  isSP ? 1.5 : 2;


        if (zoomTween) zoomTween.kill();

        if (!isZoomed) {
          const localX = pinCenterX - containerRect.left;
          const localY = pinCenterY - containerRect.top;
          const translateX = viewportCenterX - (containerRect.left + localX * zoom);
          const translateY = viewportCenterY - (containerRect.top + localY * zoom);
          zoomTween = gsap.to(container, {
            x: translateX,
            y: translateY,
            scale: zoom,
            duration: 0.8,
            ease: 'power2.out',
            onComplete: () => {
              // モーダル表示
              const modalId = trg.getAttribute('data-modal');
              const modal = document.querySelector(`.map_modal[data-modal="${modalId}"]`);
              if (!modal) return;

              gsap.killTweensOf(modal);
              gsap.to(modal, {
                autoAlpha: 1,
                duration: 0.6,
                delay: 0,
                ease: 'power2.out'
              });
              gsap.to(".c_header_logo", {
                autoAlpha: 0,
                duration: 0.6,
                delay: 0,
                ease: 'power2.out'
              });
            }
          });

          lenis.stop()
          isZoomed = true;
        }
      });
    });

    // --- モーダルクローズ処理 ---
    const closeButtons = document.querySelectorAll('.js_mapModal_close');

    closeButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const modal = btn.closest('.map_modal');
        if (!modal) return;

        gsap.killTweensOf(modal);
        gsap.to(modal, {
          autoAlpha: 0,
          duration: 0.6,
          ease: 'power2.inOut',
          onComplete: () => {
          }
        });
        zoomTween = gsap.to(container, {
          x: 0,
          y: 0,
          scale: 1,
          duration: 1.2,
          ease: 'power3.inOut'
        });
        gsap.to(".c_header_logo", {
          autoAlpha: 1,
          duration: 0.6,
          delay: 0.5,
          ease: 'power2.out'
        });
        lenis.start()
        isZoomed = false;
      });
    });


    // // モーダルの開閉 
    // const pins = document.querySelectorAll('.js_zoomTrg');

    // pins.forEach(pin => {
    //   pin.addEventListener('click', () => {
    //     const modalId = pin.getAttribute('data-modal');
    //     if (!modalId) return;

    //     // 対応するモーダルを取得
    //     const modal = document.querySelector(`.map_modal[data-modal="${modalId}"]`);
    //     if (!modal) return;

    //     // 一度全モーダルのis_openをリセット（他を閉じる）
    //     document.querySelectorAll('.map_modal.is_open').forEach(openModal => {
    //       openModal.classList.remove('is_open');
    //     });

    //     // 対応するモーダルを開く
    //     modal.classList.add('is_open');
    //   });
    // });

    // // 閉じるボタン・背景クリックで閉じる
    // document.addEventListener('click', (e) => {
    //   if (e.target.classList.contains('js_mapModal_close')) {
    //     const modal = e.target.closest('.map_modal');
    //     if (modal) modal.classList.remove('is_open');
    //   }
    // });




  }
  map_animationInit();




  ///////////////////////////////////////////////////////////////////
  // NEWSのアニメーション
  ////////////////////////////////////////////////////////////////////

  function news_animationInit() {
    if (!isTop) return;

    // マップのセクションを固定
    gsap.to(".map_container, .map_ttl", {
      y: window.innerHeight * 1,
      ease: "none",
      scrollTrigger: {
        trigger: ".news", // ← スタートトリガー
        start: "top bottom",
        endTrigger: ".news",
        // end: "top top", 
        end: `+=${window.innerHeight * 1.5}`, // ← スクロール量を1.5倍に
        scrub: true,
        // markers: true, // デバッグ用
      },
    });

    // 背景だけを遅らせて奥行きを出す
    gsap.to(".news_bg_tb", {
      y: "20%",
      ease: "none",
      scrollTrigger: {
        trigger: ".news", // ← スタートトリガー
        start: "top bottom",
        endTrigger: ".news",
        // end: "top top", 
        end: `+=${window.innerHeight * 1.5}`, // ← スクロール量を1.5倍に
        pinSpacing: false,
        scrub: true,
        // markers: true, // デバッグ用
      },
    });

    // 背景だけを遅らせて奥行きを出す
    gsap.to(".news_bg_bb", {
      y: "-20%",
      ease: "none",
      scrollTrigger: {
        trigger: ".news", // ← スタートトリガー
        start: "center center",
        endTrigger: ".news",
        // end: "top top", 
        end: `+=${window.innerHeight * 1.5}`, // ← スクロール量を1.5倍に
        pinSpacing: false,
        scrub: true,
        // markers: true, // デバッグ用
      },
    });

    const newsList = document.querySelector(".news_list");
    if (!newsList) return;

    const slideCount = newsList.querySelectorAll(".swiper-slide").length;
    const isMobile = window.innerWidth <= 767;
    const shouldDisableMotion = !isMobile && slideCount <= 3;
    const shouldDisableLoop = slideCount <= 5;

    // if (newsList && typeof Swiper !== "undefined" && !newsList.classList.contains("is-swiper-init")) {
    newsList.classList.add("is-swiper-init");
    new Swiper(".news_list", {
      modules: [Navigation],
      loop: !shouldDisableLoop,
      slidesPerView: "auto",
      spaceBetween: 24,
      speed: shouldDisableMotion ? 0 : 600,
      grabCursor: !shouldDisableMotion,
      allowTouchMove: !shouldDisableMotion,
      navigation: shouldDisableMotion
        ? false
        : {
            nextEl: ".news_nav_next",
            prevEl: ".news_nav_prev",
          },
      breakpoints: {
        768: { slidesPerView: "auto", spaceBetween: 35 },
        // 1024: { slidesPerView: "auto", spaceBetween: 35 },
      },
    });
    // }
  }
  news_animationInit();




  ///////////////////////////////////////////////////////////////////
  // FOOTERのアニメーション
  ////////////////////////////////////////////////////////////////////

  function footer_animationInit() {

    // マップのセクションを固定
    gsap.to(".c_footer_cl.__01", {
      y: "-10rem",
      ease: "none",
      scrollTrigger: {
        trigger: ".c_footer", 
        start: "top bottom",
        endTrigger: ".c_footer",
        end: "bottom bottom", 
        scrub: true,
        // markers: true, // デバッグ用
      },
    });
    // マップのセクションを固定
    gsap.to(".c_footer_cl.__02", {
      y: "-10rem",
      // x: "-5rem",
      ease: "none",
      scrollTrigger: {
        trigger: ".c_footer", 
        start: "top bottom",
        endTrigger: ".c_footer",
        end: "bottom bottom", 
        scrub: true,
        // markers: true, // デバッグ用
      },
    });
    // マップのセクションを固定
    gsap.to(".c_footer_sun", {
      // y: "10rem",
      ease: "none",
      scrollTrigger: {
        trigger: ".c_footer", 
        start: "top bottom",
        endTrigger: ".c_footer",
        end: "bottom bottom", 
        scrub: true,
        // markers: true, // デバッグ用
      },
    });
    // マップのセクションを固定
    gsap.to(".c_footer_txtArea", {
      y: "-3rem",
      ease: "none",
      scrollTrigger: {
        trigger: ".c_footer", 
        start: "top bottom",
        endTrigger: ".c_footer",
        end: "bottom bottom", 
        scrub: true,
        // markers: true, // デバッグ用
      },
    });
  }
  footer_animationInit();


  ///////////////////////////////////////////////////////////////////
  // テキストアニメーション ※ピン留めしている要素などの読み込みが完了してから呼び出さないと発火位置がズレる。
  ////////////////////////////////////////////////////////////////////
  //   setTimeout(() => {
  //   document.querySelector('.js_mediaFade').classList.add('is_animated');
  // }, 1);

  // const txtAnimationItems = gsap.utils.toArray('.js_fadeTxt');
  // txtAnimationItems.forEach((item) => {
  //     const txtAnimationTarget = item.querySelectorAll('span');
  //     gsap.to(txtAnimationTarget, {
  //       x: 0,
  //       y: 0,
  //       rotation: 0,
  //       autoAlpha: 1,
  //       duration: 0.5,
  //       scale: 1,
  //       ease: 'cubic-bezier(.72,-.3,.38,1)',
  //       scrollTrigger: {
  //         trigger: item,
  //         start: "top bottom-=35%",
  //         end: "+=200",
  //         scrub: true,
  //       },
  //       stagger: {
  //         from: "start",
  //         amount: 0.5,
  //       }
  //     });
  // });
  document.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', function (e) {
      const currentUrl = location.href.split('#')[0];
      const linkUrl = this.href.split('#')[0];

      if (currentUrl === linkUrl) {
        // 同じURLならキャンセル
        e.preventDefault();
        console.log('同じURLのため遷移キャンセル');
      }
    });
  });


  const hoverSlotTxtAnimation = gsap.utils.toArray('.js_slotTxt');

  hoverSlotTxtAnimation.forEach((item) => {
    if (!item.length) return;
    const target01 = item.querySelectorAll(':scope > span:nth-of-type(1) > span');
    const target02 = item.querySelectorAll(':scope > span:nth-of-type(2) > span');

    // inline の場合の見え方安定
    gsap.set([target01, target02], { display: 'inline-block' });

    const tl = gsap.timeline({
      paused: true,
      defaults: { duration: 1, ease: 'expo.inOut', overwrite: 'auto' }
    })
      .to(target01, {
        y: '-100%',
        rotation: 0,
        // まとまった時間で均等配分 → amount
        stagger: { from: 'start', amount: 0.2 }
      }, 0)
      .to(target02, {
        y: '-100%',
        rotation: 0,
        // 各要素ごとに固定間隔 → each（どちらでも可。好みで）
        stagger: { from: 'start', each: 0.02 }
      }, 0);

    // 直親でなくても OK（最も近い .js_slot 祖先を拾う）
    const slot = item.closest('.js_slot') || item;

    slot.addEventListener('mouseenter', () => tl.restart());
    slot.addEventListener('mouseleave', () => tl.reverse()); // 逆戻り不要なら削除
  });

  const hoverSlotArrowAnimation = gsap.utils.toArray('.js_slotArrowWrapper');
  hoverSlotArrowAnimation.forEach((item) => {
    const arrows = item.querySelectorAll('.js_slotArrow');
    if (arrows.length < 2) return; // 念のためガード

    const tl = gsap.timeline({
      paused: true,
      defaults: { duration: 1, ease: 'expo.inOut', overwrite: 'auto' }
    });

    // 初期位置をセット（2つ目は右にずらしておく）
    gsap.set(arrows[0], { xPercent: -150 });
    gsap.set(arrows[1], { xPercent: 0 });

    // アニメーション定義
    tl.to(arrows[0], { xPercent: 0 }, 0)      // 1つ目 → 0%
      .to(arrows[1], { xPercent: 100 }, 0);   // 2つ目 → 100%

    // 直親でなくても OK（最も近い .js_slot 祖先を拾う）
    const slot = item.closest('.js_slot') || item;

    slot.addEventListener('mouseenter', () => tl.restart());
    slot.addEventListener('mouseleave', () => tl.reverse()); // 逆戻り不要なら削除
  });
  // ScrollTrigger.clearScrollMemory();
  // ScrollTrigger.refresh();

}
document.addEventListener('DOMContentLoaded', commonScriptInit);


////////////////////////////////////// commonScriptInit の後に onWindowLoadScriptInitを起動するためのスクリプト
// カスタムイベントをリッスン
document.addEventListener('commonScriptInitComplete', function () {
  isCommonScriptInitComplete = true;
  checkAndRunOnWindowLoadScriptInit();
});

// window の load イベントをリッスン
window.addEventListener('load', function () {
  isWindowLoaded = true;
  checkAndRunOnWindowLoadScriptInit();
});

// 両方が完了したときに onWindowLoadScriptInit を実行
function checkAndRunOnWindowLoadScriptInit() {
  if (isWindowLoaded && isCommonScriptInitComplete) {
    onWindowLoadScriptInit();
  }
}
///////////////////////////////////////











////////////////////////////////////////////////////////////////////
// ローディング完了後に呼びだす
////////////////////////////////////////////////////////////////////

// スプラッシュ
// スプラッシュ終了後のMVアニメーション
function onLoadingComplete_mvAnimationInit() {
  setTimeout(() => {
    const innerSpans = document.querySelectorAll('.js_mv_tAnimation_01 span');
    gsap.to(innerSpans, {
      y: 0,
      rotation: 0,
      duration: 0.8,
      ease: "circ.out",
      delay: 0.2,
      // ease: "circ.inOut",
      // scrollTrigger: {
      //   trigger: item.closest?.('.js_tAnimationTrigger') || item,
      //   start: "top top", // ここは既存の定義に従ってください
      //   // start: isSP ? "bottom bottom" : "left right+=15%",
      //   // end: isSP ? `+=${window.innerHeight * 2}` : `+=${window.innerWidth * 2}`,
      //   toggleActions: 'play none none reverse',
      //   // containerAnimation: scrollAnim,
      // },
      stagger: {
        from: "start",
        amount: 0.4,
      },
      onComplete: () => {
        document.querySelectorAll('.js_mv_vivus').forEach((el) => {
          if (el) {
            gsap.to(el, {
              autoAlpha: 1,
              duration: 0,
            });
            new Vivus("js-vivus-target1", {
              // type: 'delayed',    // 描画タイプ
              // duration: 150,      // アニメーション時間
              // animTimingFunction: Vivus.EASE,
              duration: vivusAnimationDuration(400), // アニメーションの長さ
              forceRender: false, //パスが更新で再レンダリングさせない
              animTimingFunction: Vivus.EASE_OUT, // 自動開始
              start: "inViewport"
            }, () => {
              // console.log('✅ Vivusアニメーション完了！');
            });
          }
        });

      }
    });

  }, 140);
}



// ヘッダーの出現 スプラッシュの有無で変わるためかき分ける
function header_animationInit(config) {
  // デフォルト値を設定
  const defaults = {
    delayTime: 0, // 遅延時間
    duration: 0.8, // アニメーションの長さ
    y: 0, // y座標
    opacity: 1, // 不透明度
  };
  // デフォルト値とユーザー指定値をマージ
  const settings = { ...defaults, ...config };
  // アニメーション実行
  // gsap.killTweensOf(".header"); // アニメーション競合防止
  gsap.to(".c_header_nav, .c_header_logo", {
    delay: settings.delayTime,
    duration: settings.duration,
    y: settings.y,
    // opacity: settings.opacity,
    // autoAlpha: 1,
    ease: "elastic.out(1.1,0.7)",
  });
  if (window.innerWidth >= 768) {
    gsap.to(".c_newsList", {
      delay: settings.delayTime,
      duration: settings.duration,
      y: settings.y,
      // opacity: settings.opacity,
      // autoAlpha: 1,
      ease: "elastic.out(1.1,0.7)",
    });
  } else {
    gsap.to(".c_newsList", {
      delay: settings.delayTime,
      y: settings.y,
      duration: 0.2,
      autoAlpha: 1,
      overwrite: "auto",
      // ease: "elastic.out(1.1,0.7)",
      scrollTrigger: {
        trigger: document.body,
        start: 'top top-=25%',
        // end: 'bottom top',
      }
    });
    gsap.to(".a_cursor_center, .a_cursor_outer", {
      autoAlpha: 0,
      duration: 0.2,
      // ease: "none",
      scrollTrigger: {
        trigger: document.body,
        start: 'top top-=25%',
      },
    });
  }
  // const headerNewsList = document.querySelector('.c_newsList');
  // if (headerNewsList) {
  //   ScrollTrigger.create({
  //     trigger: document.body,
  //     start: 'top top-=50%',
  //     end: 'bottom top',
  //     onEnter: () => gsap.to(headerNewsList, { autoAlpha: 0, duration: 0.2, overwrite: 'auto' }),
  //     onLeaveBack: () => gsap.to(headerNewsList, { autoAlpha: 1, duration: 0.2, overwrite: 'auto' })
  //   });
  // }
}




////////////////////////////////////////////////////////////////////
// ローディングの有無での分岐 ＆　スプラッシュ
////////////////////////////////////////////////////////////////////
const splashAnimationInit = () => {
  lenis.stop();
  var target = document.querySelector('.loading');
  var path = window.location.pathname
  const hasSession = sessionStorage.getItem('gpm_loading_seen') === '1';
  if (
    target &&
    !hasSession &&
    path !== '/contact/' &&
    path !== '/confirm/' &&
    path !== '/complete/'
  ) {
    //////////////////////////////////////////
    //  loadingがある場合
    //////////////////////////////////////////

    // MVのレイヤーそれぞれをまず非表示
    gsap.set(".loading_f1", { autoAlpha: 1 });


    phase1();

    function phase1() {
      const el = document.querySelector('.loading_f1_num');
      const wrapper = document.querySelector('.loading_f1_wrapper');
      const h = document.querySelector('.loading_f1_h');
      const waves = document.querySelectorAll('.loading_f1_wave');
      if (!el || !wrapper) return;

      // 数字ノードを特定
      const numberTextNode =
        [...el.childNodes].find((n) => n.nodeType === Node.TEXT_NODE) || el;

      const format = (v) => {
        const iv = Math.floor(v);
        return String(Math.min(iv, 100)).padStart(3, '0');
      };

      const state = { value: 0 };
      const render = () => {
        const txt = format(state.value);
        if (numberTextNode.nodeType === 3) {
          numberTextNode.nodeValue = txt;
        } else {
          el.textContent = txt + '%';
        }
        // wrapper の移動もここで直接反映
        wrapper.style.transform = `translateX(${state.value * 0.7}vw)`;
      };

      render();

      const cfg = {
        plateau: 77,
        preDuration: 2.5,
        preEase: 'none',
        finishDuration: 1,
        finishEase: 'power2.out',
      };

      let isWindowLoaded = false;
      let isInitComplete = false;
      let preTween;

      // 0→77
      function startPreTween() {
        preTween = gsap.to(state, {
          value: cfg.plateau,
          duration: cfg.preDuration,
          ease: cfg.preEase,
          onUpdate: render,
          onComplete: () => {
            isInitComplete = true;
            checkAndRunFinish('カウントアップの処理');
          },
        });
      }

      // 77→100
      function runFinish() {
        if (runFinish._done) return;
        runFinish._done = true;

        if (preTween && preTween.isActive()) preTween.kill();

        gsap.to(state, {
          value: 100,
          duration: cfg.finishDuration,
          ease: cfg.finishEase,
          onUpdate: render,
          onComplete: () => {
            render();
            gsap.to(wrapper, {
              x: state.value * 1.2 + 'vw',
              opacity: 0,
              duration: 0.8,
              delay: 1,
              onComplete: () => {
                // 終了したCSSアニメーションを解除（キャッシュ済み要素を使用）
                h?.classList.remove('a_shake');
                waves.forEach((el) => el.classList.remove('a_wave'));
                // フェーズ2へ
                phase2();
              },
            });
          },
        });
      }

      function checkAndRunFinish(stage) {
        if (isWindowLoaded && isInitComplete) {
          runFinish();
        }
      }

      startPreTween();

      window.addEventListener('load', () => {
        isWindowLoaded = true;
        checkAndRunFinish('ロード完了');
      });
    }
    function phase2() {
      const el = document.querySelector('.loading_f2');
      if (!el) return;
      gsap.to(el, {
        autoAlpha: 1,
        duration: 0.4,
        onComplete: () => {
          phase3()
        },
      });
    }
    // スキップボタンを設けた場合にはフェーズ3まで飛ばす。
    function phase3() {
      gsap.to('.loading', {
        autoAlpha: 0,
        duration: 0.4,
        delay: 1.2,
        onComplete: () => {
          // loading 終了
          gsap.to('.mv_layer', {
            opacity: 1,
            duration: 1,
            delay: 1.2,
            onComplete: () => {
              sessionStorage.setItem('gpm_loading_seen', '1');
              lenis.start();
              swichImgInit();
              header_animationInit()
              gsap.to('.a_cursor', {
                autoAlpha: 1,
                duration: 0.4,
              });
            }
          });
        },
      });

    }
  } else {
    function phase3() {
      gsap.to('.loading', {
        autoAlpha: 0,
        duration: 0.4,
        delay: 0,
        onComplete: () => {
          // loading 終了
          gsap.to('.mv_layer', {
            opacity: 1,
            duration: 1,
            delay: 0,
            onComplete: () => {
              sessionStorage.setItem('gpm_loading_seen', '1');
              lenis.start();
              swichImgInit();
              header_animationInit()
              gsap.to('.a_cursor', {
                autoAlpha: 1,
                duration: 0.4,
              });
            }
          });
        },
      });
    }
    phase3()
  }
};

window.addEventListener('DOMContentLoaded', function () {
  splashAnimationInit();
});
window.addEventListener('load', function () {
});
webglWaveInit()

// mvFrontNoise();

// pageLeaveAnimationPixel();

